// extracted by mini-css-extract-plugin
export var methodItem = "styles-module--methodItem--6OVkA";
export var image = "styles-module--image--JwXJA";
export var container = "styles-module--container--8p3vv";
export var title = "styles-module--title--WJlHB";
export var description = "styles-module--description--AHm2O";
export var number = "styles-module--number--3EcoZ";